import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeleteButtonComponent } from './delete-button.component';
import { SvgIconModule } from '../svg-icon';
import { SimpleModalModule } from '../simple-modal/simple-modal.module';
import { LoadingComponentModule } from '../loading/loading.module';
import { InputFieldModule } from '../input-field/input-field.module';

@NgModule({
    declarations: [
        DeleteButtonComponent,
    ],
    exports: [
        DeleteButtonComponent,

    ],
    imports: [
        CommonModule,
        SvgIconModule,
        SimpleModalModule,
        InputFieldModule,
        LoadingComponentModule
    ]
})
export class DeleteButtonModule { }
